module.exports = __webpack_public_path__ + "img/bh_6.49d7e35d.jpg";